'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var index = require('react-transition-group/cjs/index');
var core_Card_Thumbnail_style = require('./Thumbnail.style.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LazyImage = function LazyImage(_ref) {
  var inViewport = _ref.inViewport,
    fallbackSrc = _ref.fallbackSrc,
    src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    alt = _ref.alt,
    fitThumbnail = _ref.fitThumbnail;
  var _React$useState = React__default["default"].useState(false),
    _React$useState2 = _slicedToArray__default["default"](_React$useState, 2),
    isLoaded = _React$useState2[0],
    setIsLoaded = _React$useState2[1];
  var _React$useState3 = React__default["default"].useState(false),
    _React$useState4 = _slicedToArray__default["default"](_React$useState3, 2),
    isError = _React$useState4[0],
    setIsError = _React$useState4[1];
  if (!inViewport || isError) {
    return react.jsx(core_Card_Thumbnail_style.SImage, _extends__default["default"]({}, fallbackSrc ? {
      src: fallbackSrc
    } : {}, {
      isHidden: fallbackSrc ? false : true
    }));
  }
  return react.jsx(index.Transition, {
    in: isLoaded,
    timeout: 300
  }, function (transitionState) {
    return react.jsx(core_Card_Thumbnail_style.SImage, {
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      alt: alt,
      fitThumbnail: fitThumbnail,
      isHidden: transitionState !== 'entered',
      transitionDuration: 300,
      onLoad: function onLoad() {
        return setIsLoaded(true);
      },
      onError: function onError() {
        return setIsError(true);
      }
    });
  });
};
var Thumbnail = function Thumbnail(_ref2) {
  var thumbnail = _ref2.thumbnail,
    _ref2$fallbackSrc = _ref2.fallbackSrc,
    fallbackSrc = _ref2$fallbackSrc === void 0 ? '' : _ref2$fallbackSrc,
    vertical = _ref2.vertical,
    fitThumbnail = _ref2.fitThumbnail,
    alt = _ref2.alt,
    _ref2$thumbnailRadius = _ref2.thumbnailRadius,
    thumbnailRadius = _ref2$thumbnailRadius === void 0 ? true : _ref2$thumbnailRadius,
    srcSet = _ref2.srcSet,
    sizes = _ref2.sizes,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'grid' : _ref2$type,
    _ref2$lazy = _ref2.lazy,
    lazy = _ref2$lazy === void 0 ? false : _ref2$lazy,
    _ref2$inViewport = _ref2.inViewport,
    inViewport = _ref2$inViewport === void 0 ? true : _ref2$inViewport;
  return react.jsx(core_Card_Thumbnail_style.SThumbnail, {
    thumbnail: thumbnail,
    vertical: vertical,
    type: type,
    thumbnailRadius: thumbnailRadius
  }, thumbnail && react.jsx(core_Card_Thumbnail_style.SThumbnailInner, null, lazy ? react.jsx(LazyImage, {
    inViewport: inViewport,
    src: thumbnail,
    fallbackSrc: fallbackSrc,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt,
    fitThumbnail: fitThumbnail
  }) : react.jsx(core_Card_Thumbnail_style.SImage, {
    src: thumbnail,
    srcSet: srcSet,
    sizes: sizes,
    fitThumbnail: fitThumbnail,
    alt: alt
  })));
};

exports.Thumbnail = Thumbnail;
//# sourceMappingURL=Thumbnail.js.map
